(function () {
  'use strict';

  var POLL_INTERVAL = 250;
  var MAX_WAIT = 6000;

  function isOnlineLocation(loc) {
    if (!loc) return false;
    // The app's "online store" pseudo-location carries no physical address
    // or coordinates — every real store location does. This is how we tell
    // the warehouse apart from a shop without hardcoding a location id.
    return !loc.latitude && !(loc.address1 && loc.address1.length);
  }

  function computeState(entry, market) {
    if (!entry || !entry.inventoryLocations) return null;

    var onlineQty = 0;
    var storeQty = 0;
    var storeNames = [];

    entry.inventoryLocations.forEach(function (item) {
      var qty = Math.max(0, item.quantity || 0);
      var location = item.location;
      if (isOnlineLocation(location)) {
        onlineQty += qty;
      } else if (location && location.countryCode === market) {
        storeQty += qty;
        if (qty > 0) storeNames.push(location.name);
      }
    });

    return { onlineQty: onlineQty, storeQty: storeQty, storeNames: storeNames };
  }

  function render(container, strings, state) {
    if (!state) return; // fail open: leave Shopify's native state untouched

    var label;
    var note = '';
    var notice = '';

    if (state.onlineQty >= 1) {
      container.className = 'availability-state availability-state--online';
      label = strings.online;
    } else if (state.storeQty >= 1) {
      container.className = 'availability-state availability-state--store-only';
      label = strings.store_only;
      if (state.storeNames.length) note = strings.store_only_at.replace('{location}', state.storeNames.join(', '));
      // Wuohi 19.10.2026: asiakkaan pyytämä huomautus myymäläsaldojen epävarmuudesta (sv/en käännöstiedostoista).
      notice = strings.store_only_note || '';
    } else {
      container.className = 'availability-state availability-state--unavailable';
      label = strings.unavailable;
    }

    container.innerHTML =
      '<strong class="availability-state__label">' + label + '</strong>' +
      (note ? '<p class="availability-state__note">' + note + '</p>' : '') +
      (notice ? '<p class="availability-state__note availability-state__notice">' + notice + '</p>' : '');
    container.hidden = false;
  }

  function findEntry(handle, variantId) {
    var info = window.inventoryInfo;
    if (!info || !info[handle] || !info[handle].data) return null;
    var list = info[handle].data.variantLocations;
    if (!list) return null;
    for (var i = 0; i < list.length; i++) {
      if (String(list[i].variant) === String(variantId)) return list[i];
    }
    return null;
  }

  function readStrings(container) {
    var node = document.getElementById(container.dataset.stringsId);
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return null;
    }
  }

  // Fallback when the Multi-Location Inv. app is not installed (e.g. the
  // Swedish store): use the Flow-maintained custom.variant_store_only
  // metafield ({variant_id: {se: bool, fi: bool, ...}}). It only knows the
  // "store only" case, so anything else stays hidden (fail open).
  function readStoreOnlyMap(container) {
    if (!container.dataset.storeOnlyMap) return null;
    try {
      return JSON.parse(container.dataset.storeOnlyMap);
    } catch (e) {
      return null;
    }
  }

  function fallbackState(container, variantId) {
    var map = readStoreOnlyMap(container);
    var key = container.dataset.marketKey;
    if (!map || !key || !map[String(variantId)]) return null;
    if (map[String(variantId)][key] === true) {
      var stores = map[String(variantId)].stores || {};
      var names = Object.keys(stores).filter(function (n) { return stores[n] > 0; });
      return { onlineQty: 0, storeQty: 1, storeNames: names, fallback: true };
    }
    return null;
  }

  // Store availability drawer: fills the static store list with the
  // variant's per-store quantities from the metafield map. The opener link
  // is only shown when the map has data for the variant, so a product the
  // Flow hasn't touched yet simply shows no link (fail open).
  function renderStores(container, strings, variantId, variantTitle) {
    var opener = container.parentNode.querySelector('[data-availability-stores]');
    var drawer = container.parentNode.querySelector('side-drawer[data-name="store-availability"]');
    if (!opener || !drawer) return;

    var map = readStoreOnlyMap(container);
    var entry = map && map[String(variantId)];
    if (!entry) {
      opener.hidden = true;
      return;
    }
    var stores = entry.stores || {};

    drawer.querySelectorAll('[data-store-name]').forEach(function (item) {
      var qty = stores[item.dataset.storeName] || 0;
      var inStock = qty > 0;
      item.querySelector('[data-store-icon="in"]').hidden = !inStock;
      item.querySelector('[data-store-icon="out"]').hidden = inStock;
      item.querySelector('[data-store-status]').textContent = inStock
        ? strings.in_stock_qty.replace('{count}', qty)
        : strings.out_of_stock;
    });

    if (!variantTitle) {
      try {
        var titles = JSON.parse(drawer.dataset.variantTitles || '{}');
        variantTitle = titles[String(variantId)];
      } catch (err) { variantTitle = null; }
    }
    var titleEl = drawer.querySelector('[data-store-variant-title]');
    if (titleEl && variantTitle) titleEl.textContent = variantTitle;

    opener.hidden = false;
  }

  function init(container) {
    var handle = container.dataset.productHandle;
    var market = (container.dataset.market || '').toUpperCase();
    var strings = readStrings(container);
    if (!strings) return;

    renderStores(container, strings, container.dataset.variantId);

    // Stores without the inventory app (e.g. Sweden) have no window.inventoryInfo
    // to wait for: show the metafield fallback right away and let the app's
    // richer data replace it if it ever arrives.
    var initialFallback = fallbackState(container, container.dataset.variantId);
    if (initialFallback) render(container, strings, initialFallback);

    var waited = 0;
    var timer = setInterval(function () {
      waited += POLL_INTERVAL;
      var entry = findEntry(handle, container.dataset.variantId);
      if (entry) {
        clearInterval(timer);
        render(container, strings, computeState(entry, market));
      } else if (waited >= MAX_WAIT) {
        clearInterval(timer);
        // The app's data never showed up — keep/apply the metafield fallback,
        // otherwise leave the native state as-is.
        if (!initialFallback) render(container, strings, fallbackState(container, container.dataset.variantId));
      }
    }, POLL_INTERVAL);

    var update = function (variantId, variantTitle) {
      container.dataset.variantId = variantId;
      renderStores(container, strings, variantId, variantTitle);
      var entry = findEntry(handle, variantId);
      if (entry) {
        render(container, strings, computeState(entry, market));
      } else {
        var fb = fallbackState(container, variantId);
        if (fb) {
          render(container, strings, fb);
        } else {
          container.hidden = true;
        }
      }
    };

    document.addEventListener('variant:change', function (e) {
      if (e.detail && e.detail.variant) update(e.detail.variant.id, e.detail.variant.title);
    });

    document.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'id') update(e.target.value);
    });
  }

  document.querySelectorAll('[data-availability-state]').forEach(init);
})();
